import React, {Component} from "react";
import PropTypes from "prop-types";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import {Col, ControlLabel, FormControl, FormGroup, Grid, Row} from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import rest from '../../API/api';

var crypto = require('crypto');

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      alert: null
    };
    this.logUserIn = this.logUserIn.bind(this);
    this.buildHashfromPassword = this.buildHashfromPassword.bind(this);
    this.state = {
        authenticated : false,
        admin : false,
        subscription: "",
        role: "",
        Userid: "",
        Email: "",
        Fname: "",
        Lname: "",
        cloudinary_upload: "",
        cloudinary_destory: "",
        apiKeyCloudinary: "",
        apiSecretKeyCloudinary: "",
        apiKey: ""
      }
  }

  componentDidMount() {
    setTimeout(
      function() {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
      this.state = {
          authenticated : false,
          admin : false,
          role: ""
      }
  }
  static get contextTypes() {
    return {
        router: PropTypes.object
    };
  }

  successAlert(authenticated){
      //Setup the alert and use the context to route to the home page once logged in.
      if(authenticated) {
          this.setState({
              alert: (
                  <SweetAlert
                      success
                      title="You have been logged in!"
                      style={{display: "block"}}
                      onConfirm={() => this.context.router.history.push("/Home")}
                      onCancel={() => this.context.router.history.push("/Home")}
                      confirmBtnBsStyle="info"
                  >
                  </SweetAlert>
              )
          });
          setTimeout(() =>
            {this.setState({
              alert: null
            });
              this.context.router.history.push("/Home")}, 3000);
      }
      else
      {
          this.setState({
              alert: (
                  <SweetAlert
                      danger
                      style={{display: "block"}}
                      title="Invalid Username or Password, please try again!"
                      onConfirm={() => this.setState({alert: null})}
                      onCancel={() => this.setState({alert: null})}
                      confirmBtnBsStyle="danger"
                  >
                  </SweetAlert>
              )
          });
      }
  }
    /*User Schema method that is used to set the user password.  However we are not storing the actual password, just the
  hash and the salt.  The Salt is used with the users password to build the Hash
  */
    /*

    userSchema.methods.setPassword = function(password){
        this.Salt = crypto.randomBytes(16).toString('hex');
        this.Hash = crypto.pbkdf2Sync(password, this.Salt, 1000, 64, 'sha512').toString('hex');
    };

*/
    /*User Schema method that takes the current password and combines with the stored hash to see whether the resulting Hash
    matches the Hash stored in the database.
    */

    buildHashfromPassword = function(salt,password) {
        return crypto.pbkdf2Sync(password, salt, 1000, 64, 'sha512').toString('hex');
    };
    logUserIn(event) {
        event.preventDefault();

        //First lets get the salt from the user database, build the hash with salt+password, the make a second REST call
        //to authenticate passing the userid and the hash

        //Lets do a fetch to the APIGateway and log the user in based on their creds
        // The fetch's `then` gets a Response instance back
        fetch(rest.getUserSalt,{
            method: 'POST',
            body: JSON.stringify({
                username: document.getElementById('username').value

            }),
            insecure:true,
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key' : rest.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                //Check to see if the User Id existed, if not throw up an alert
                if(!data.exist)
                {  
                    this.successAlert(false);
                    return;
                }
                //console.log(data);
                var myhash = this.buildHashfromPassword(data.salt,document.getElementById('password').value);
                //console.log(myhash);
                //console.log(data.admin);
                //console.log('parsed json', data);
                //Now lets make another rest call and see if we can authenticate the user
                fetch(rest.loginUser,{
                    method: 'POST',
                    body: JSON.stringify({
                        username: document.getElementById('username').value,
                        hash: myhash
                    }),
                    insecure:true,
                    headers: new Headers({
                        'Content-Type': 'application/json;charset=UTF-8',
                        'x-api-key' : rest.apiKey
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        //Lets calculate their subscription status, store it and compare it to the existing
                        //status stored in the tenant record, if its different, update the tenant record.
                        var subscriptionStatus;
                        var tenantDate = new Date(data.SubscriptionDate);
                        var today = new Date();
                        var dd = today.getDate();
                        var mm = today.getMonth() + 1; //January is 0!
                        var yyyy = today.getFullYear();
                        if (dd < 10) {
                            dd = '0' + dd;
                        }
                        if (mm < 10) {
                            mm = '0' + mm;
                        }
                        var today_s = mm + '/' + dd + '/' + yyyy;
                        var todayDate = new Date(today_s);
                        subscriptionStatus = tenantDate - todayDate >= 0;
                        this.setState({
                            authenticated: data.authenticated,
                            admin: data.admin,
                            role: data.role,
                            Userid: data.Userid,
                            Email: data.Email,
                            Fname: data.Fname,
                            Lname: data.Lname,
                            subscription:subscriptionStatus,
                            _id: data._id,
                            cloudinary_upload: data.cloudinary_upload,
                            cloudinary_destory: data.cloudinary_destory,
                            apiKeyCloudinary: data.apiKeyCloudinary,
                            apiSecretKeyCloudinary: data.apiSecretKeyCloudinary,
                            apiKey: data.apiKey
                        });
                        //Lets update the subscription status on the tenant record if they are different
                        if((data.SubscriptionStatus !== subscriptionStatus) && (data.authenticated)) {
                            let tempURL = rest.tenants + '/' + data._id;
                            let tempAPIKey = data.apiKey;
                            //Current Tenant record that we will need to update
                            //Update the main MongoDB record
                            fetch(tempURL, {
                                method: 'PUT',
                                //Use the API key that was sent via user login request
                                headers: new Headers({
                                    'Content-Type': 'application/json;charset=UTF-8',
                                    'x-api-key': data.apiKey
                                }),
                                body: JSON.stringify({
                                    SubscriptionStatus: subscriptionStatus,
                                }),
                            })
                                .then(response => response.json())
                                .then(data => {

                                })
                                .catch(error => console.error(error));
                        }

                        //console.log(data.authenticated);
                        //console.log(data.admin);
                        //console.log('parsed json', data);
                        //Check to see if the user authenticated

                        this.props.actions.logUserIn({
                            status: data.authenticated,
                            role: data.role,
                            Userid: data.Userid,
                            Email: data.Email,
                            Fname: data.Fname,
                            Lname: data.Lname,
                            subscription: subscriptionStatus,
                            _id: data._id,
                            cloudinary_upload: data.cloudinary_upload,
                            cloudinary_destory: data.cloudinary_destory,
                            apiKeyCloudinary: data.apiKeyCloudinary,
                            apiSecretKeyCloudinary: data.apiSecretKeyCloudinary,
                            apiKey: data.apiKey
                            //role: this.state.admin ? "admin" : "user"
                        });
                        this.successAlert(data.authenticated);
                    })
                    .catch(error => console.error(error));

                //Check to see if the user authenticated

                //User failed so throw up an Alert and let them try again

            })
            .catch(error => console.error(error));

    }
  render() {
      //let test = this.props.userLoggedIn;
      //debugger;
    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3} xs={10} xsOffset={1}>
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Login"
                content={
                  <div>
                    <FormGroup>
                      <ControlLabel>Username</ControlLabel>
                      <FormControl id="username" placeholder="Enter your username" type="text" />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Password</ControlLabel>
                      <FormControl id="password" placeholder="Password" type="password" />
                    </FormGroup>
                      {/*
                    <FormGroup>
                      <Checkbox number="1" label="Subscribe to newsletter" />
                    </FormGroup>*/}
                  </div>
                }
                legend={
                  <Button bsStyle="info" fill wd onClick={this.logUserIn}>
                    Login
                  </Button>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
          {this.state.alert}
      </Grid>
    );
  }
}

LoginPage.propTypes = {
    actions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    //debugger;
    return {
        userLoggedIn: state.userLoggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(loginActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);


//export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx